export default "__VITE_ASSET__BVRgdbgj__"